import { Box, Card, CardContent, Container, Grid, Typography, Tabs, Tab } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getHotelList } from '../apis/hotelApis'
import { OverlayLoader } from '../components/Loader'
import { useNavigate } from 'react-router'
import { CardImage } from '../components/CardImage'
import { environment } from '../environments/environment'
import { useState } from 'react'
import { groupBy, sortBy } from 'lodash'

export const Home = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['getHotelList'],
    queryFn: getHotelList,
  })
  const navigate = useNavigate()
  const [selectedTab, setSelectedTab] = useState(0)

  const activeHotels = data?.filter((hotel) => hotel.isActive) || []
  const hotelsByLocation = groupBy(activeHotels, (hotel) => hotel.location || 'Other')

  const locationOrder = ['Đà Nẵng', 'Nha Trang', 'Hồ Chí Minh', 'Quy Nhơn']
  const locations = sortBy(Object.keys(hotelsByLocation), (location) => {
    const index = locationOrder.indexOf(location)
    return index === -1 ? locationOrder.length + location.charCodeAt(0) : index
  })

  const selectedLocation = locations[selectedTab]
  const hotelsInSelectedLocation = hotelsByLocation[selectedLocation] || []

  if (isLoading) {
    return <OverlayLoader />
  }

  return (
    <Container>
      <Box textAlign="center" mt={3} mb={3}>
        <Typography variant="h5" fontWeight={500}>
          Bạn đang ở khách sạn nào?
        </Typography>
      </Box>

      {locations.length > 1 && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs
            value={selectedTab}
            onChange={(_, newValue) => setSelectedTab(newValue)}
            variant="fullWidth"
            sx={{ minHeight: 48 }}>
            {locations.map((location, index) => (
              <Tab key={location} label={location} value={index} />
            ))}
          </Tabs>
        </Box>
      )}

      <Grid
        container
        spacing={{
          xs: 1,
          sm: 2,
        }}
        paddingX={{
          xs: 1,
          sm: 2,
        }}>
        {hotelsInSelectedLocation.map((item) => (
          <Grid item xs={6} sm={4} key={item.hotelId}>
            <Card
              sx={{ height: '100%' }}
              onClick={() => navigate(environment.kiosk ? `/hotel/${item.hotelId}/devices` : `/hotel/${item.hotelId}`)}>
              <CardImage image={item.imageUrl} />
              <CardContent>
                <Typography>{item.hotelName}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}
